import { render, staticRenderFns } from "./google-map.vue?vue&type=template&id=4585c05b&scoped=true"
import script from "./google-map.vue?vue&type=script&lang=js"
export * from "./google-map.vue?vue&type=script&lang=js"
import style0 from "./google-map.vue?vue&type=style&index=0&id=4585c05b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585c05b",
  null
  
)

export default component.exports